import { render, staticRenderFns } from "./ChatPage.vue?vue&type=template&id=1fe5db4b&scoped=true"
import script from "./ChatPage.vue?vue&type=script&lang=js"
export * from "./ChatPage.vue?vue&type=script&lang=js"
import style0 from "./ChatPage.vue?vue&type=style&index=0&id=1fe5db4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe5db4b",
  null
  
)

export default component.exports